import { api } from '@/lib/utils'

export default async function fetcher(url: string) {
  const { data } = await api.get(url)
  return data
}
